/* Arflonia: graue Texte auf hellem Grund -> schwarz
   2026-10-28 Claude: gleiche Regel wie vorher, aber schneller:
   - Arbeit in kleinen Paketen (max. ~8 ms), damit der Haupt-Thread nicht blockiert (TBT)
   - erst alle Farben lesen, dann schreiben (keine erzwungenen Layout-Neuberechnungen)
   - Hintergrund-Ergebnisse pro Durchlauf zwischengespeichert */
(function(){
  var INK='#111111';
  var cache=new WeakMap();
  function rgb(s){var m=s&&s.match(/rgba?\(([^)]+)\)/);if(!m)return null;var p=m[1].split(/[ ,\/]+/).filter(Boolean).map(parseFloat);return {r:p[0],g:p[1],b:p[2],a:p.length>3?p[3]:1};}
  function lum(c){return 0.299*c.r+0.587*c.g+0.114*c.b;}
  var WHITE={r:255,g:255,b:255,a:1};
  function bgOf(el){
    var chain=[],res;
    while(el&&el.nodeType===1){
      if(cache.has(el)){res=cache.get(el);break;}
      chain.push(el);
      var cs=getComputedStyle(el);
      var c=rgb(cs.backgroundColor);if(c&&c.a>0.5){res=c;break;}
      var bi=cs.backgroundImage;
      if(bi!=='none'){var g=bi.match(/rgba?\([^)]+\)/);if(/gradient/.test(bi)&&g){var gc=rgb(g[0]);if(gc&&gc.a>0.3){res=gc;break;}}else{res=null;break;}}
      el=el.parentElement;
    }
    if(res===undefined)res=WHITE;
    for(var i=0;i<chain.length;i++)cache.set(chain[i],res);
    return res;
  }
  function isGrey(c){var r=c.r,g=c.g,b=c.b;if(c.a<1){r=r*c.a+255*(1-c.a);g=g*c.a+255*(1-c.a);b=b*c.a+255*(1-c.a);}var mx=Math.max(r,g,b),mn=Math.min(r,g,b);return (mx-mn)<=48&&mx>=45&&mx<=215;}
  function needs(e){
    if(!e.isConnected||e.closest('svg,input,textarea,select,option,[data-keep-grey]'))return false;
    var t=false;for(var n=e.firstChild;n;n=n.nextSibling){if(n.nodeType===3&&n.nodeValue.trim()){t=true;break;}}
    if(!t)return false;
    var c=rgb(getComputedStyle(e).color);if(!c||!isGrey(c))return false;
    var bg=bgOf(e);return !!(bg&&lum(bg)>=170);
  }
  var queue=[],pos=0,busy=false;
  var later=window.requestIdleCallback?function(f){requestIdleCallback(f,{timeout:300});}:function(f){setTimeout(f,16);};
  function pump(){
    var t0=Date.now(),hits=[];
    while(pos<queue.length&&Date.now()-t0<8){var e=queue[pos++];if(needs(e))hits.push(e);}
    for(var i=0;i<hits.length;i++)hits[i].style.setProperty('color',INK,'important');
    if(pos<queue.length){later(pump);}else{queue=[];pos=0;busy=false;cache=new WeakMap();}
  }
  function fix(root){
    if(!root||!root.querySelectorAll)return;
    var els=root.querySelectorAll('*');
    for(var i=0;i<els.length;i++)queue.push(els[i]);
    if(!busy){busy=true;later(pump);}
  }
  function run(){fix(document.body);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
  window.addEventListener('load',run);
  var q=null;new MutationObserver(function(ms){if(q)return;q=setTimeout(function(){q=null;ms.forEach(function(m){m.addedNodes.forEach(function(n){if(n.nodeType===1){fix(n.parentElement||n);}});});},120);}).observe(document.documentElement,{childList:true,subtree:true});
})();
